// src/entities/BlogPost.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
const getToken = () => localStorage.getItem('token');

// פונקציה ליצירת ה-headers הנכונים לכל קריאה מאומתת
const getAuthHeaders = () => {
  const token = getToken();
  if (!token) return {};
  // שימוש בשיטה שאושרה על ידך
  return { 'Authorization': `Bearer ${token}` };
};

export function stripHtml(html) {
  const tmp = document.createElement('DIV');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
}

export const BlogPost = {
  // פונקציית list נשארת עם fetch כרגע, כי היא לא דורשת אימות
  list: async (lang = 'he', sortBy = '-created_date', limit = 0, filter = {}) => {
    const queryParams = new URLSearchParams({ sortBy, limit: limit.toString(), lang, ...filter }).toString();
    const response = await fetch(`${API_URL}/posts/published?${queryParams}`);
    if (!response.ok) throw new Error('Failed to fetch posts');
    const data = await response.json();
    return data.map(post => ({ ...post, id: post._id }));
  },

  listAll: async (lang = 'he', sortBy = '-created_date', limit = 0, filter = {}) => {
    const queryParams = new URLSearchParams({ sortBy, limit: limit.toString(), lang, ...filter }).toString();
    // --- שינוי: שימוש בכותרת האימות הנכונה ---
    const response = await fetch(`${API_URL}/posts?${queryParams}`, {
      headers: getAuthHeaders(),
    });
    if (!response.ok) throw new Error('Failed to fetch all posts');
    const data = await response.json();
    return data.map(post => ({ ...post, id: post._id }));
  },

  filter: async (filters, lang = 'he', sortBy = '-created_date', limit = 0) => {
    return BlogPost.list(lang, sortBy, limit, filters);
  },

  get: async (id) => {
    // נשאר עם fetch, לא דורש אימות
    const response = await fetch(`${API_URL}/posts/${id}`);
    if (!response.ok) throw new Error(`Failed to fetch post with id ${id}`);
    return response.json();
  },

  // --- תיקון: הפונקציה create תוקנה ---
  create: async (postData) => {
    if (!getToken()) throw new Error('Authentication token not found');

    // היא מקבלת 'postData', ומשתמשת בו. ומחזירה את התשובה.
    const response = await axios.post(
        `${API_URL}/posts/create`,
        postData, // שימוש בפרמטר הנכון
        {
          headers: getAuthHeaders()
        }
    );
    return response.data; // החזרת המידע מהשרת
  },

  update: async (id, data) => {
    if (!getToken()) throw new Error('Authentication token not found');
    // --- שינוי: שימוש בכותרת האימות הנכונה עם fetch ---
    const response = await fetch(`${API_URL}/posts/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders()
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `Failed to update post with id ${id}`);
    }
    return response.json();
  },

  delete: async (id) => {
    if (!getToken()) throw new Error('Authentication token not found');
    // --- שינוי: שימוש בכותרת האימות הנכונה עם fetch ---
    const response = await fetch(`${API_URL}/posts/${id}`, {
      method: 'DELETE',
      headers: getAuthHeaders(),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `Failed to delete post with id ${id}`);
    }
    return response.json();
  },

  schema: () => {
    return {
      type: 'object',
      properties: {
        title: { type: 'string', description: 'Post title' },
        content: { type: 'string', description: 'Post content' },
        excerpt: { type: 'string', description: 'Post excerpt' },
        category: {
          type: 'string',
          enum: ['computer_science', 'judaism_philosophy', 'art', 'neuroscience', 'psychology', 'other'],
          description: 'Post category',
        },
        imageUrl: { type: 'string', description: 'Post image URL' },
        isFeatured: { type: 'boolean', default: false, description: 'Is it a featured post?' },
        is_published: { type: 'boolean', default: false, description: 'Is the post published?' },
        language: {
          type: 'string',
          enum: ['he', 'en'],
          default: 'he',
          description: 'The language of the post'
        },
        translationOf: {
          type: 'string',
          description: 'ID of the original post (if this is a translation)'
        }
      },
      required: ['title', 'content', 'category', 'language'],
    };
  },
};